import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const BridgeRepository = RepositoryFactory.get('RailwayRepository')['BridgeRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(BridgeRepository)

export const STORE_MODULE_NAME = 'bridge';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
